import React from "react";

const Kotlin_Arrays = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Kotlin Arrays</h1>
      <p>Content for Kotlin Arrays goes here.</p>
    </div>
  );
};

export default Kotlin_Arrays;
